import styled from 'styled-components';

import { Swiper, SwiperSlide } from 'swiper/react';

import PcMainBanner from './images/pc_top_banner.png';
import MbMainBanner from './images/mb_top_banner.png';

export const StyledMainBanner = styled.div`
    background-image: url('${PcMainBanner}');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-color: transparent;

    height: 40vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    text-align: center;
    color: #ffffff;

    .headTitle {
        font-size: 4vw;
        font-weight: 900;
        line-height: 5.7919vw;
    }

    .bodyText {
        font-size: 1.625vw;
        font-weight: 300;
        line-height: 2.3531vw;
    }

    @media screen and (min-width: 1599px) {
        .headTitle {
            font-size: 64px;
            font-weight: 700;
            line-height: 92.67px;
        }

        .bodyText {
            font-size: 26px;
            line-height: 37.65px;
        }
    }

    @media (max-width: 767px) {
        background-image: url('${MbMainBanner}');
        height: 177.7344vw;

        .headTitle {
            font-size: 6.6667vw;
            line-height: 9.6536vw;
        }

        .headTitle.jp {
            font-size: 6vw;
        }

        .bodyText {
            font-size: 3.3333vw;
            font-weight: 400;
            line-height: 4.8268vw;
        }

        .bodyText.jp {
            font-size: 2.9vw;
        }
    }
`;

export const StyledTechnology = styled.div`
    p {
        margin: 0;
    }

    .technology_1 {
        display: flex;
        justify-content: center;

        > div {
            position: relative;
            width: 75vw;
            height: 25vw;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .technologyTitle {
                font-size: 1.625vw;
                font-weight: 500;
                line-height: 2.3531vw;
                text-align: left;
                color: #00a5fa;
            }

            .technologyText {
                font-size: 3.25vw;
                font-weight: 900;
                line-height: 4.7062vw;
                text-align: left;
            }

            .technologyImg {
                display: flex;
                height: 100%;

                img {
                    position: relative;
                    margin: auto auto 0;
                    width: 27vw;
                    height: 18vw;
                }
            }
        }
    }

    .technology_2 {
        position: relative;
        margin: -1.25vw 0 3vw;

        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 1.25vw;

        img {
            width: 36.875vw;
            height: 21.125vw;
        }

        .technologyTitle {
            margin: 1.25vw 0 0.5vw;
            font-size: 1.625vw;
            font-weight: 700;
            line-height: 2.3531vw;
        }

        .technologyText {
            font-size: 1.125vw;
            font-weight: 400;
            line-height: 1.6287vw;
        }
    }

    @media screen and (min-width: 1599px) {
        .technology_1 {
            > div {
                width: 1200px;
                height: 400px;

                .technologyTitle {
                    font-size: 26px;
                    line-height: 37.65px;
                }

                .technologyText {
                    font-size: 52px;
                    line-height: 75.3px;
                }

                .technologyImg {
                    img {
                        width: 432px;
                        height: 288px;
                    }
                }
            }
        }

        .technology_2 {
            margin: -20px 0 48px;
            gap: 20px;

            img {
                width: 590px;
                height: 338px;
            }

            .technologyTitle {
                margin: 20px 0 8px;
                font-size: 26px;
                line-height: 37.65px;
            }

            .technologyText {
                font-size: 18px;
                line-height: 26.06px;
            }
        }
    }

    @media (max-width: 767px) {
        .technology_1 {
            > div {
                width: 88.8021vw;
                height: 32.5521vw;

                .technologyTitle {
                    font-size: 4.444vw;
                    line-height: 6.4362vw;
                }

                .technologyText {
                    font-weight: 700;
                    font-size: 6.6667vw;
                    line-height: 9.6536vw;
                }

                .technologyImg {
                    img {
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        width: 29.444vw;
                        height: 19.7227vw;
                    }
                }
            }
        }

        .technology_2 {
            margin: -20px 0 48px;
            gap: 5.599vw;

            > div {
                text-align: center;
            }

            img {
                width: 88.8893vw;
                height: 51.1107vw;
            }

            .technologyTitle {
                margin: 2.2135vw 0 1.1068vw;
                font-size: 4.444vw;
                line-height: 6.4362vw;
            }

            .technologyText {
                font-size: 3.3333vw;
                line-height: 4.8268vw;
            }
        }
    }
`;

export const StyledSolution = styled.div`
    background: #fafafa;
    display: flex;
    justify-content: center;

    p {
        margin: 0;
    }

    > div {
        width: 75vw;
        margin-bottom: 9.1875vw;
    }

    .solutionTitle {
        margin: 5.8125vw 0 1vw;
        font-size: 1.625vw;
        font-weight: 700;
        line-height: 2.3531vw;
        color: #00a5fa;
    }

    .solutionPagination {
        width: 100%;
        background: #ffffff;
        border-radius: 2vw;
        margin-bottom: 3vw;

        .swiper-pagination-bullet {
            background: none;
            width: 15vw;
            color: #000000;
            opacity: 1;
            text-align: center;
            height: 4vw;
            line-height: 4vw;
            margin: 0;
            font-size: 1.25vw;
            font-weight: 700;
        }

        .swiper-pagination-bullet-active {
            color: #ffffff;
            background: #000000;
            border-radius: 2vw;
        }
    }

    .moreBtn {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border: none;
        box-sizing: border-box;
        cursor: pointer;
        background-color: none;
    }

    @media screen and (min-width: 1599px) {
        > div {
            width: 1200px;
            margin-bottom: 147px;
        }

        .solutionTitle {
            margin: 93px 0 16px;
            font-size: 26px;
            line-height: 37.65px;
        }

        .solutionPagination {
            border-radius: 32px;
            margin-bottom: 48px;

            .swiper-pagination-bullet {
                width: 240px;
                height: 64px;
                line-height: 64px;
                font-size: 20px;
            }

            .swiper-pagination-bullet-active {
                border-radius: 32px;
            }
        }
    }

    @media (max-width: 767px) {
        > div {
            width: 88.8021vw;
            margin-bottom: 13.2643vw;
        }

        .solutionTitle {
            margin-top: 10.026vw;
            font-size: 4.444vw;
            line-height: 6.4362vw;
        }

        .solutionPagination {
            width: 0;
            height: 0;
            overflow: hidden;
        }
    }
`;

export const StyledSolutionSwiper = styled(Swiper)`
    .swiper-slide:not(.swiper-slide-active) {
        opacity: 0 !important;
    }

    .solution-swiper-navi-prev,
    .solution-swiper-navi-next {
        cursor: pointer;

        svg {
            width: 0px;
            height: 0px;
        }
    }

    @media (max-width: 767px) {
        .swiperNaviWrapper {
            margin-top: 4.5573vw;
            display: flex;
            justify-content: space-between;
            align-items: center;

            > div {
                display: flex;
                gap: 4.444vw;
            }

            svg {
                width: 31.1107vw;
                height: 8.8893vw;
            }
        }

        .solution-swiper-navi-prev,
        .solution-swiper-navi-next {
            svg {
                width: 8.8893vw;
                height: 8.8893vw;
            }
        }
    }
`;

export const StyledSolutionPcSwiperSlide = styled(SwiperSlide)`
    background: #fafafa;

    .solutionWrapper {
        display: flex;
        justify-content: space-between;
        gap: 1.6875vw;
    }

    .solutionContent {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .solutionLogo {
        width: auto;
        height: 4.0938vw;
    }

    .solutionTxt {
        font-weight: 700;
        margin-bottom: 1.25vw;
    }

    .solutionTxt.ko {
        font-size: 2.5vw;
        line-height: 3.62vw;
    }

    .solutionTxt.en,
    .solutionTxt.jp {
        font-size: 2vw;
        line-height: 2.8963vw;
    }

    .solutionImageWrapper {
        position: relative;

        svg {
            position: absolute;
            width: 11.4375vw;
            height: 3.5625vw;
            top: 19.5625vw;
            right: 1.5vw;
        }
    }

    .solutionImg {
        width: 42.9375vw;
        height: 24.625vw;
        border-radius: 0.625vw;
    }

    @media screen and (min-width: 1599px) {
        .solutionWrapper {
            gap: 27px;
        }

        .solutionLogo {
            height: 65.5px;
        }

        .solutionTxt {
            margin-bottom: 20px;
        }

        .solutionTxt.ko {
            font-size: 40px;
            line-height: 57.92px;
        }

        .solutionTxt.en,
        .solutionTxt.jp {
            font-size: 32px;
            line-height: 46.34px;
        }

        .solutionImageWrapper {
            svg {
                width: 183px;
                height: 57px;
                top: 313px;
                right: 24px;
            }
        }

        .solutionImg {
            width: 687px;
            height: 394px;
            border-radius: 10px;
        }
    }
`;

export const StyledSolutionMbSwiperSlide = styled(SwiperSlide)`
    background: #fafafa;

    .solutionTxt {
        font-size: 6.6667vw;
        font-weight: 700;
        line-height: 9.6536vw;
        text-align: left;
    }

    .solutionLogo {
        width: auto;
        height: 8.5938vw;
    }

    .solutionImg {
        width: 88.8893vw;
        height: 51.1107vw;
        border-radius: 2.7773vw;
    }

    .solutionBtnWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 4.4271vw;
    }

    .solutionNaviWrapper {
        display: flex;
        gap: 4.4271vw;
    }

    .solution-swiper-navi-prev,
    .solution-swiper-navi-next {
        cursor: pointer;

        svg {
            width: 8.8542vw;
            height: 8.8542vw;
        }
    }
`;

export const StyledNews = styled.div`
    height: 50vw;

    .newsTitle {
        font-weight: 900;
        text-align: center;
        font-size: 3.25vw;
        line-height: 4.7062vw;
        padding-top: 6.8125vw;
    }

    .newsContents {
        position: relative;
        width: 87.5vw;
        left: 50%;
        transform: translateX(-50%);

        .swiper-navi {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;

            svg {
                width: 3.125vw;
                height: 3.125vw;
            }
        }

        .news-swiper-navi-next {
            right: 0;
        }
    }

    @media screen and (min-width: 1599px) {
        height: 800px;

        .newsTitle {
            font-size: 52px;
            line-height: 75.3px;
            padding-top: 109px;
        }

        .newsContents {
            width: 1400px;

            .swiper-navi {
                svg {
                    width: 50px;
                    height: 50px;
                }
            }
        }
    }

    @media (max-width: 767px) {
        height: 101.5625vw;

        .newsTitle {
            font-size: 6.6667vw;
            line-height: 9.6536vw;
            padding-top: 11.7188vw;
            font-weight: 700;
        }

        .newsContents {
            width: 182.2917vw;
        }
    }
`;

export const StyledNewsSwiper = styled(Swiper)`
    width: 75vw;

    @media screen and (min-width: 1599px) {
        width: 1200px;
    }

    @media (max-width: 767px) {
        width: 182.2917vw;
    }
`;

export const StyledNewsSwiperSlide = styled(SwiperSlide)`
    cursor: pointer;

    p {
        margin: 0;
    }

    > div {
        display: flex;
        justify-content: center;
        width: fit-content;

        left: 50%;
        position: relative;
        transform: translateX(-50%);
    }

    .newsImg {
        width: 24vw;
        height: 24vw;
    }

    .newsSlide {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        padding: 1.25vw 1.25vw 0.5vw 1.25vw;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        > div:first-child {
            min-height: 8.4375vw;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }

    .newsTxt {
        font-weight: 700;
        color: #ffffff;
        font-size: 1.625vw;
        line-height: 2.3531vw;
        overflow: hidden;
        text-overflow: ellipsis;

        display: -webkit-box; // 얘네를 추가히준다
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }

    .newsTxt.jp {
        word-break: break-all;
    }

    .newsDate {
        font-weight: 700;
        color: #ffffff;
        font-size: 1.125vw;
        line-height: 1.6287vw;
    }

    .newsChannel {
        display: flex;
        justify-content: center;
        align-items: center;
        align-self: end;
        color: #ffffff;
        background-color: #1e1e1e;
        opacity: 0.5;
        width: 10.75vw;
        height: 3vw;
        border-radius: 1.25vw;

        p {
            font-weight: 700;
            text-align: center;
            font-size: 1.125vw;
            line-height: 1.6287vw;
        }
    }

    @media screen and (min-width: 1599px) {
        .newsImg {
            width: 384px;
            height: 384px;
        }

        .newsSlide {
            padding: 20px 20px 8px 20px;

            > div:first-child {
                min-height: 135px;
            }
        }

        .newsTxt {
            font-size: 26px;
            line-height: 37.65px;
        }

        .newsDate {
            font-size: 18px;
            line-height: 26.06px;
        }

        .newsChannel {
            width: 172px;
            height: 48px;
            border-radius: 20px;

            p {
                font-size: 18px;
                line-height: 26.06px;
            }
        }
    }

    @media (max-width: 767px) {
        .newsImg {
            width: 57.8125vw;
            height: 57.8125vw;
        }

        .newsSlide {
            padding: 2.2135vw;

            > div:first-child {
                min-height: 26.3021vw;
            }
        }

        .newsTxt {
            font-size: 4.444vw;
            line-height: 6.4362vw;
        }

        .newsDate {
            font-size: 3.3333vw;
            line-height: 4.7018vw;
            font-weight: 500;
        }

        .newsChannel {
            width: 24.4792vw;
            height: 6.6406vw;
            border-radius: 5.5339vw;

            p {
                font-size: 3.6107vw;
                line-height: 5.2292vw;
            }
        }
    }
`;

export const SwiperPrevBtn = () => {
    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="50"
                height="50"
                rx="25"
                transform="matrix(4.37114e-08 1 1 -4.37114e-08 0 0)"
                fill="#232323"
            />
            <path d="M30 16L20 25.5L30 35" stroke="white" strokeWidth="3" />
        </svg>
    );
};

export const SwiperNextBtn = () => {
    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="50"
                width="50"
                height="50"
                rx="25"
                transform="rotate(90 50 0)"
                fill="#232323"
            />
            <path d="M20 16L30 25.5L20 35" stroke="white" strokeWidth="3" />
        </svg>
    );
};

export const SwiperPcMoreViewBtn = (props) => {
    const { onClick } = props;

    return (
        <svg
            onClick={onClick}
            style={{ cursor: 'pointer' }}
            width="183"
            height="57"
            viewBox="0 0 183 57"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="183" height="57" rx="10" fill="#00A9FF" />
            <path
                d="M31.9534 36.5V23.162H34.9054L37.1734 29.426C37.3174 29.822 37.4554 30.242 37.5874 30.686C37.7194 31.118 37.8514 31.544 37.9834 31.964H38.0734C38.2174 31.544 38.3554 31.118 38.4874 30.686C38.6194 30.242 38.7454 29.822 38.8654 29.426L41.0974 23.162H44.0494V36.5H41.6194V30.938C41.6194 30.506 41.6374 30.032 41.6734 29.516C41.7094 29 41.7514 28.484 41.7994 27.968C41.8594 27.44 41.9134 26.972 41.9614 26.564H41.8894L40.7914 29.696L38.7394 35.294H37.2094L35.1394 29.696L34.0774 26.564H34.0054C34.0534 26.972 34.1014 27.44 34.1494 27.968C34.1974 28.484 34.2394 29 34.2754 29.516C34.3234 30.032 34.3474 30.506 34.3474 30.938V36.5H31.9534ZM51.2951 36.752C50.4551 36.752 49.6631 36.542 48.9191 36.122C48.1871 35.702 47.5931 35.102 47.1371 34.322C46.6811 33.53 46.4531 32.576 46.4531 31.46C46.4531 30.344 46.6811 29.396 47.1371 28.616C47.5931 27.824 48.1871 27.218 48.9191 26.798C49.6631 26.378 50.4551 26.168 51.2951 26.168C51.9311 26.168 52.5371 26.288 53.1131 26.528C53.6891 26.768 54.2051 27.116 54.6611 27.572C55.1171 28.016 55.4771 28.568 55.7411 29.228C56.0051 29.876 56.1371 30.62 56.1371 31.46C56.1371 32.576 55.9091 33.53 55.4531 34.322C54.9971 35.102 54.3971 35.702 53.6531 36.122C52.9211 36.542 52.1351 36.752 51.2951 36.752ZM51.2951 34.592C51.7511 34.592 52.1351 34.466 52.4471 34.214C52.7711 33.95 53.0111 33.584 53.1671 33.116C53.3351 32.648 53.4191 32.096 53.4191 31.46C53.4191 30.824 53.3351 30.272 53.1671 29.804C53.0111 29.336 52.7711 28.976 52.4471 28.724C52.1351 28.46 51.7511 28.328 51.2951 28.328C50.8391 28.328 50.4491 28.46 50.1251 28.724C49.8131 28.976 49.5731 29.336 49.4051 29.804C49.2491 30.272 49.1711 30.824 49.1711 31.46C49.1711 32.096 49.2491 32.648 49.4051 33.116C49.5731 33.584 49.8131 33.95 50.1251 34.214C50.4491 34.466 50.8391 34.592 51.2951 34.592ZM58.3507 36.5V26.42H60.5107L60.7087 28.202H60.7627C61.1347 27.542 61.5727 27.038 62.0767 26.69C62.5807 26.342 63.0967 26.168 63.6247 26.168C63.9127 26.168 64.1407 26.192 64.3087 26.24C64.4887 26.276 64.6507 26.324 64.7947 26.384L64.3627 28.67C64.1707 28.622 63.9967 28.586 63.8407 28.562C63.6967 28.526 63.5107 28.508 63.2827 28.508C62.8987 28.508 62.4907 28.658 62.0587 28.958C61.6387 29.258 61.2847 29.768 60.9967 30.488V36.5H58.3507ZM70.3013 36.752C69.3653 36.752 68.5193 36.542 67.7633 36.122C67.0073 35.702 66.4013 35.096 65.9453 34.304C65.5013 33.512 65.2793 32.564 65.2793 31.46C65.2793 30.644 65.4053 29.912 65.6573 29.264C65.9213 28.616 66.2753 28.064 66.7193 27.608C67.1753 27.14 67.6793 26.786 68.2313 26.546C68.7953 26.294 69.3773 26.168 69.9773 26.168C70.9013 26.168 71.6753 26.378 72.2993 26.798C72.9233 27.206 73.3913 27.776 73.7033 28.508C74.0273 29.228 74.1893 30.056 74.1893 30.992C74.1893 31.232 74.1773 31.466 74.1533 31.694C74.1293 31.91 74.0993 32.084 74.0633 32.216H67.8533C67.9253 32.756 68.0873 33.212 68.3393 33.584C68.5913 33.956 68.9153 34.238 69.3113 34.43C69.7073 34.61 70.1573 34.7 70.6613 34.7C71.0693 34.7 71.4533 34.646 71.8133 34.538C72.1733 34.418 72.5393 34.244 72.9113 34.016L73.8113 35.636C73.3193 35.972 72.7673 36.242 72.1553 36.446C71.5433 36.65 70.9253 36.752 70.3013 36.752ZM67.7993 30.434H71.9213C71.9213 29.762 71.7653 29.228 71.4533 28.832C71.1533 28.424 70.6733 28.22 70.0133 28.22C69.6653 28.22 69.3353 28.304 69.0233 28.472C68.7113 28.628 68.4473 28.874 68.2313 29.21C68.0153 29.534 67.8713 29.942 67.7993 30.434ZM82.7144 36.5L79.2764 26.42H81.9404L83.3984 31.442C83.5424 31.946 83.6804 32.456 83.8124 32.972C83.9564 33.476 84.0944 33.986 84.2264 34.502H84.3164C84.4484 33.986 84.5804 33.476 84.7124 32.972C84.8564 32.456 84.9944 31.946 85.1264 31.442L86.6024 26.42H89.1404L85.7744 36.5H82.7144ZM90.8175 36.5V26.42H93.4635V36.5H90.8175ZM92.1495 24.782C91.6815 24.782 91.3095 24.656 91.0335 24.404C90.7575 24.14 90.6195 23.786 90.6195 23.342C90.6195 22.91 90.7575 22.562 91.0335 22.298C91.3095 22.034 91.6815 21.902 92.1495 21.902C92.5935 21.902 92.9595 22.034 93.2475 22.298C93.5355 22.562 93.6795 22.91 93.6795 23.342C93.6795 23.786 93.5355 24.14 93.2475 24.404C92.9595 24.656 92.5935 24.782 92.1495 24.782ZM100.676 36.752C99.7403 36.752 98.8943 36.542 98.1383 36.122C97.3823 35.702 96.7763 35.096 96.3203 34.304C95.8763 33.512 95.6543 32.564 95.6543 31.46C95.6543 30.644 95.7803 29.912 96.0323 29.264C96.2963 28.616 96.6503 28.064 97.0943 27.608C97.5503 27.14 98.0543 26.786 98.6063 26.546C99.1703 26.294 99.7523 26.168 100.352 26.168C101.276 26.168 102.05 26.378 102.674 26.798C103.298 27.206 103.766 27.776 104.078 28.508C104.402 29.228 104.564 30.056 104.564 30.992C104.564 31.232 104.552 31.466 104.528 31.694C104.504 31.91 104.474 32.084 104.438 32.216H98.2283C98.3003 32.756 98.4623 33.212 98.7143 33.584C98.9663 33.956 99.2903 34.238 99.6863 34.43C100.082 34.61 100.532 34.7 101.036 34.7C101.444 34.7 101.828 34.646 102.188 34.538C102.548 34.418 102.914 34.244 103.286 34.016L104.186 35.636C103.694 35.972 103.142 36.242 102.53 36.446C101.918 36.65 101.3 36.752 100.676 36.752ZM98.1743 30.434H102.296C102.296 29.762 102.14 29.228 101.828 28.832C101.528 28.424 101.048 28.22 100.388 28.22C100.04 28.22 99.7103 28.304 99.3983 28.472C99.0863 28.628 98.8223 28.874 98.6063 29.21C98.3903 29.534 98.2463 29.942 98.1743 30.434ZM108.242 36.5L105.65 26.42H108.278L109.394 31.388C109.478 31.892 109.556 32.384 109.628 32.864C109.7 33.344 109.778 33.836 109.862 34.34H109.952C110.06 33.836 110.162 33.344 110.258 32.864C110.354 32.372 110.462 31.88 110.582 31.388L111.806 26.42H114.146L115.406 31.388C115.526 31.892 115.634 32.384 115.73 32.864C115.826 33.344 115.934 33.836 116.054 34.34H116.126C116.222 33.836 116.306 33.344 116.378 32.864C116.462 32.384 116.552 31.892 116.648 31.388L117.71 26.42H120.176L117.692 36.5H114.578L113.516 32.108C113.408 31.628 113.306 31.154 113.21 30.686C113.126 30.206 113.03 29.696 112.922 29.156H112.832C112.748 29.696 112.664 30.206 112.58 30.686C112.496 31.166 112.4 31.64 112.292 32.108L111.266 36.5H108.242Z"
                fill="white"
            />
            <path
                d="M147.17 27.5L144.59 24.91L146 23.5L151 28.5L146 33.5L144.59 32.09L147.17 29.5H131V27.5H147.17Z"
                fill="white"
            />
        </svg>
    );
};

export const SwiperMbMoreViewBtn = (props) => {
    const { onClick } = props;

    return (
        <svg
            onClick={onClick}
            style={{ cursor: 'pointer' }}
            width="240"
            height="70"
            viewBox="0 0 240 70"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.666626"
                y="0.867188"
                width="238.933"
                height="68.2667"
                rx="21.3333"
                fill="#00A9FF"
            />
            <path
                d="M25.4332 44.2656V25.3984H28.8636L32.294 34.9472C32.5158 35.5616 32.7292 36.1931 32.934 36.8416C33.1388 37.4731 33.3436 38.1046 33.5484 38.736H33.6764C33.8982 38.1046 34.103 37.4731 34.2908 36.8416C34.4956 36.1931 34.7004 35.5616 34.9052 34.9472L38.2844 25.3984H41.7404V44.2656H38.9756V34.9472C38.9756 34.384 38.9926 33.7611 39.0268 33.0784C39.078 32.3958 39.1292 31.7046 39.1804 31.0048C39.2486 30.3051 39.3169 29.6736 39.3852 29.1104H39.2572L37.7468 33.4624L34.47 42.448H32.6268L29.3244 33.4624L27.814 29.1104H27.7116C27.7798 29.6736 27.8396 30.3051 27.8908 31.0048C27.959 31.7046 28.0102 32.3958 28.0444 33.0784C28.0956 33.7611 28.1212 34.384 28.1212 34.9472V44.2656H25.4332ZM52.0848 44.624C50.9242 44.624 49.832 44.3339 48.808 43.7536C47.801 43.1563 46.9818 42.3115 46.3504 41.2192C45.736 40.1099 45.4288 38.7787 45.4288 37.2256C45.4288 35.6555 45.736 34.3243 46.3504 33.232C46.9818 32.1227 47.801 31.2779 48.808 30.6976C49.832 30.1174 50.9242 29.8272 52.0848 29.8272C52.9381 29.8272 53.7658 29.9979 54.568 30.3392C55.3701 30.6635 56.0784 31.1414 56.6928 31.7728C57.3072 32.4043 57.7936 33.1808 58.152 34.1024C58.5104 35.007 58.6896 36.048 58.6896 37.2256C58.6896 38.7787 58.3738 40.1099 57.7424 41.2192C57.128 42.3115 56.3173 43.1563 55.3104 43.7536C54.3205 44.3339 53.2453 44.624 52.0848 44.624ZM52.0848 42.1664C52.8186 42.1664 53.4501 41.9616 53.9792 41.552C54.5253 41.1424 54.9434 40.5707 55.2336 39.8368C55.5237 39.0859 55.6688 38.2155 55.6688 37.2256C55.6688 36.2358 55.5237 35.3739 55.2336 34.64C54.9434 33.8891 54.5253 33.3088 53.9792 32.8992C53.4501 32.4726 52.8186 32.2592 52.0848 32.2592C51.3338 32.2592 50.6853 32.4726 50.1392 32.8992C49.6101 33.3088 49.2005 33.8891 48.9104 34.64C48.6202 35.3739 48.4752 36.2358 48.4752 37.2256C48.4752 38.2155 48.6202 39.0859 48.9104 39.8368C49.2005 40.5707 49.6101 41.1424 50.1392 41.552C50.6853 41.9616 51.3338 42.1664 52.0848 42.1664ZM62.1772 44.2656V30.16H64.5836L64.8396 32.6944H64.8908C65.4028 31.7899 66.0086 31.0902 66.7084 30.5952C67.4081 30.0832 68.142 29.8272 68.91 29.8272C69.2513 29.8272 69.5414 29.8528 69.7804 29.904C70.0193 29.9552 70.2497 30.0235 70.4716 30.1088L69.9596 32.6944C69.7036 32.6091 69.4732 32.5494 69.2684 32.5152C69.0636 32.4811 68.8161 32.464 68.526 32.464C67.9628 32.464 67.3654 32.6944 66.734 33.1552C66.1025 33.599 65.5649 34.384 65.1212 35.5104V44.2656H62.1772ZM78.1402 44.624C76.8602 44.624 75.6996 44.3339 74.6586 43.7536C73.6175 43.1563 72.7898 42.3115 72.1754 41.2192C71.561 40.1099 71.2538 38.7787 71.2538 37.2256C71.2538 36.0822 71.433 35.0582 71.7914 34.1536C72.1498 33.232 72.6362 32.4555 73.2506 31.824C73.865 31.1755 74.5562 30.6806 75.3242 30.3392C76.0922 29.9979 76.8772 29.8272 77.6794 29.8272C78.9252 29.8272 79.9748 30.1088 80.8282 30.672C81.6815 31.2182 82.33 31.9947 82.7738 33.0016C83.2175 33.9915 83.4394 35.152 83.4394 36.4832C83.4394 36.7734 83.4223 37.055 83.3882 37.328C83.3711 37.584 83.337 37.8059 83.2858 37.9936H74.1466C74.2319 38.8811 74.4623 39.6491 74.8378 40.2976C75.2303 40.9291 75.7338 41.424 76.3482 41.7824C76.9796 42.1238 77.6964 42.2944 78.4986 42.2944C79.13 42.2944 79.7188 42.2006 80.265 42.0128C80.8111 41.8251 81.3402 41.5691 81.8522 41.2448L82.8762 43.1136C82.2276 43.5403 81.5023 43.8987 80.7002 44.1888C79.9151 44.479 79.0618 44.624 78.1402 44.624ZM74.121 35.9456H80.8794C80.8794 34.751 80.6063 33.8208 80.0602 33.1552C79.5311 32.4896 78.7546 32.1568 77.7306 32.1568C77.1503 32.1568 76.6042 32.3019 76.0922 32.592C75.5802 32.8822 75.145 33.3088 74.7866 33.872C74.4452 34.4352 74.2234 35.1264 74.121 35.9456ZM95.5742 44.2656L90.6334 30.16H93.6286L96.035 37.7632C96.2398 38.4459 96.4446 39.1456 96.6494 39.8624C96.8542 40.5622 97.059 41.2619 97.2638 41.9616H97.3662C97.588 41.2619 97.8014 40.5622 98.0062 39.8624C98.211 39.1456 98.4072 38.4459 98.595 37.7632L101.001 30.16H103.869L99.0302 44.2656H95.5742ZM106.452 44.2656V30.16H109.396V44.2656H106.452ZM107.937 27.5488C107.374 27.5488 106.922 27.3867 106.58 27.0624C106.256 26.7382 106.094 26.303 106.094 25.7568C106.094 25.2448 106.256 24.8267 106.58 24.5024C106.922 24.1782 107.374 24.016 107.937 24.016C108.466 24.016 108.901 24.1782 109.243 24.5024C109.584 24.8267 109.755 25.2448 109.755 25.7568C109.755 26.303 109.584 26.7382 109.243 27.0624C108.901 27.3867 108.466 27.5488 107.937 27.5488ZM119.715 44.624C118.435 44.624 117.275 44.3339 116.234 43.7536C115.193 43.1563 114.365 42.3115 113.75 41.2192C113.136 40.1099 112.829 38.7787 112.829 37.2256C112.829 36.0822 113.008 35.0582 113.366 34.1536C113.725 33.232 114.211 32.4555 114.826 31.824C115.44 31.1755 116.131 30.6806 116.899 30.3392C117.667 29.9979 118.452 29.8272 119.254 29.8272C120.5 29.8272 121.55 30.1088 122.403 30.672C123.257 31.2182 123.905 31.9947 124.349 33.0016C124.793 33.9915 125.014 35.152 125.014 36.4832C125.014 36.7734 124.997 37.055 124.963 37.328C124.946 37.584 124.912 37.8059 124.861 37.9936H115.722C115.807 38.8811 116.037 39.6491 116.413 40.2976C116.805 40.9291 117.309 41.424 117.923 41.7824C118.555 42.1238 119.271 42.2944 120.074 42.2944C120.705 42.2944 121.294 42.2006 121.84 42.0128C122.386 41.8251 122.915 41.5691 123.427 41.2448L124.451 43.1136C123.803 43.5403 123.077 43.8987 122.275 44.1888C121.49 44.479 120.637 44.624 119.715 44.624ZM115.696 35.9456H122.454C122.454 34.751 122.181 33.8208 121.635 33.1552C121.106 32.4896 120.33 32.1568 119.306 32.1568C118.725 32.1568 118.179 32.3019 117.667 32.592C117.155 32.8822 116.72 33.3088 116.362 33.872C116.02 34.4352 115.798 35.1264 115.696 35.9456ZM130.505 44.2656L126.716 30.16H129.686L131.555 37.7888C131.691 38.4715 131.819 39.1456 131.939 39.8112C132.058 40.4598 132.186 41.1254 132.323 41.808H132.451C132.587 41.1254 132.724 40.4598 132.86 39.8112C133.014 39.1456 133.176 38.4715 133.347 37.7888L135.343 30.16H138.057L140.079 37.7888C140.25 38.4715 140.412 39.1456 140.566 39.8112C140.719 40.4598 140.873 41.1254 141.027 41.808H141.155C141.291 41.1254 141.419 40.4598 141.539 39.8112C141.675 39.1456 141.812 38.4715 141.948 37.7888L143.766 30.16H146.556L142.895 44.2656H139.363L137.571 37.3024C137.4 36.6368 137.246 35.9712 137.11 35.3056C136.973 34.64 136.828 33.9488 136.675 33.232H136.547C136.393 33.9488 136.248 34.6486 136.111 35.3312C135.992 35.9968 135.847 36.6624 135.676 37.328L133.935 44.2656H130.505Z"
                fill="white"
            />
            <path
                d="M204.296 32.7365L198.792 27.2111L201.8 24.2031L212.467 34.8698L201.8 45.5365L198.792 42.5285L204.296 37.0031H169.8V32.7365H204.296Z"
                fill="white"
            />
        </svg>
    );
};
